module.exports = __webpack_public_path__ + "static/media/the winter moon perched.1a48fac1.png";